import { cva } from 'class-variance-authority'

export const accordionItemStyle = cva(
  `
  border-b
  border-neutral-200
`,
  {
    variants: {
      variant: {
        default: '',
        text: 'border-none',
        lineItem: 'p-6 border-none',
        header: 'border-none h3',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const accordionTriggerStyle = cva(
  `
    flex
    w-full
    items-center
    justify-between
    py-4
    transition-all
    transform
    [&[data-state=open]>span>svg]:rotate-[-180deg]
    cursor-pointer
  `,
  {
    variants: {
      variant: {
        default: `
          font-medium
          text-sm
          items-center
          justify-between
        `,
        text: `
          flex-row 
          w-full
          py-2
          gap-x-2 
          font-medium
          text-sm
          underline
          hover:underline
        `,
        header: `
          text-lg
          leading-[140%]
          font-primary
          items-center
          justify-between
          hover:no-underline
        `,
        lineItem: `
          font-medium
          text-sm
          items-center
          justify-between
        `,
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const accordionContentStyle = cva(
  `
    overflow-hidden
    text-sm
    transition-all
    text-neutral-600
    data-[state=closed]:animate-accordion-up
    data-[state=open]:animate-accordion-down
  `,
  {
    variants: {
      variant: {
        default: '',
        text: '',
        header: '',
        lineItem: '',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const accordionIconStyle = cva(
  `
    shrink-0
    transition-transform
    duration-200
    W-4
  `,
  {
    variants: {
      variant: {
        default: 'h-4 w-4 text-neutral-500',
        text: `
          h-4 
          w-4
          mt-[3px]
          text-neutral-900
        `,
        header: 'h-5 w-5 text-neutral-500',
        lineItem: 'h-5 w-5 text-neutral-500',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)
